"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireWildcard(require("./Icon"));
const _excluded = ["fill"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IconInfo = _ref => {
  let {
      fill
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    label: "Info"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58462 0 0 3.58462 0 8C0 12.4154 3.58462 16 8 16C12.4154 16 16 12.4154 16 8C16 3.58462 12.4154 0 8 0ZM8.80771 11.9999H7.19232V7.19224H8.80771V11.9999ZM7.19232 5.61543H8.80771V4.00005H7.19232V5.61543Z",
    fill: fill
  }));
};
IconInfo.defaultProps = {
  fill: 'black',
  width: '16',
  height: '16'
};
IconInfo.propTypes = Object.assign({}, _Icon.propTypes, {
  fill: _propTypes.default.string,
  width: _propTypes.default.string,
  height: _propTypes.default.string
});
var _default = exports.default = IconInfo;